export enum ApplicationServicesEnum {
    SourceOfReferral = "SourceOfReferral",
    Gender = "Gender",
    LineOfService = "LineOfService",
    WeekDayRange = "WeekDayRange",
    PatientStatus = "PatientStatus",
    PhoneType = "PhoneType"
}
